import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import logo1 from "../assets/Logo1.png";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import down1 from "../assets/Down1.png";
import right from "../assets/Right.svg";
import trans from "../assets/Transport.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import dock from "../assets/Dock.svg";
import icon from "../assets/Icon.png";
import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import ind from "../assets/India.png";
import mala from "../assets/Mala.png";
import dubai from "../assets/Dubai.png";
import london from "../assets/London.png";
import len from "../assets/Lentera.png";
import osai from "../assets/Osai.png";
import man from "../assets/Man.png";
import twit from "../assets/Twit.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import riarr from "../assets/Rightarr.svg";
import one from "../assets/Phone.png";
import ee from "../assets/Email.png";
import o1 from "../assets/O1.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import down from "../assets/Down.svg";
import o5 from "../assets/O5.png";
import logo from "../assets/logo.png";
import trial from "../assets/Trial.png";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import email1 from "../assets/Mail1.png";
import phone1 from "../assets/Phone1.png";
import keesha from "../assets/Keesha.png";
import du from "../assets/Du.png";
import lon from "../assets/Lon.png";
import "../components/Part.css";

const Partner = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Partner");
  const [showDropdown, setShowDropdown] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
const [hoveredItem, setHoveredItem] = useState(null);
  const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");

      const [name, setName] = useState("");
  const [emaill, setEmaill] = useState("");


  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");



const handleSubmitt = async () => {
  if (!name || !emaill || !phone || !message) {
    toast.error("Please fill out all the fields.");
    return;
  }

  try {
    const response = await fetch(
      "https://api-uat.mawalog.com/admin/v2/api/website",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": token,
        },
        body: JSON.stringify({
          session_id: sessionid,
          name: name,
          email: emaill,
          phone: phone,
          message: message,
        }),
      }
    );

    const result = await response.json();
    console.log("Response:", result);

    if (response.ok) {
      // ✅ API Success
      toast.success(result.message || "Message sent successfully!");
      setName("");
      setEmaill("");
      setPhone("");
      setMessage("");
    } else {
      // ❌ API returned a validation error
      toast.error(result.message || "Validation error");
    }
  } catch (error) {
    console.error("Error sending request:", error);
    toast.error("Something went wrong. Please try again.");
  }
};


  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };

  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);

  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }

    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");

    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);

  /* -- reload button click ------------------------------------------------------- */
  const handleReload = () => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const getInputStyle = (name) => ({
    width: "100%",
    padding: "12px 16px",
    fontSize: "clamp(12px, 1.5vw, 14px)",
    marginBottom: "16px",
    borderRadius: "12px",
    border: focusedField === name ? "2px solid #004BA8" : "1px solid #e0e0e0",
    outline: "none",
    boxSizing: "border-box",
    transition: "border 0.2s ease-in-out",
  });

  const handleClick = (item) => {
    setActiveItem(item);

    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }

    if (item === "Pricing") {
      navigate("/new");
    }

    if (item === "Home") {
      navigate("/");
    }

    if (item === "Say Hello") {
      navigate("/contact");
    }

    if (item === "Partner") {
      navigate("/part");
    }
  };

  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };

  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];

  const dropdownItems = [
    {
      title: "LOGISTICS OPERATIONS",
      items: [
        {
          name: "Gate",
          description: (
            <>
              Helps organizations track and manage
              <br />
              visitors efficiently.
            </>
          ),
          icon: gate,
        },
        // {
        //   icon: dock,
        //   name: "Dock",
        //   description:
        //     "Helps businesses streamline loading, unloading & scheduling.",
        // },
        // {
        //   icon: sign,
        //   name: "Signage",
        //   description:
        //     "Creating, managing & displaying digital content on screens.",
        // },
      ],
    },
    // {
    //   title: "TRACKING SYSTEM",
    //   items: [
    //     {
    //       icon: trans,
    //       name: "Transport",
    //       description:
    //         "Helps users efficiently manage & optimize transportation services.",
    //     },
    //     {
    //       icon: bus,
    //       name: "Vehicle Management",
    //       description:
    //         "Tracks vehicles, optimizes routes, and automates expenses.",
    //     },
    //     {
    //       icon: asset,
    //       name: "Asset",
    //       description:
    //         "Helps businesses track, monitor, and manage assets efficiently.",
    //     },
    //   ],
    // },
    {
      title: "WORKFORCE MANAGEMENT",
      items: [
        {
          name: "MeetQ",
          description: (
            <>
              Book & manage meeting rooms
              <br />
              with real-time tracking.
            </>
          ),
          icon: q,
        },
        // {
        //   icon: tg,
        //   name: "TickGo",
        //   description: "Track tasks, log hours, and update statuses.",
        // },
        // {
        //   icon: n,
        //   name: "Nexus",
        //   description: "Manage attendance, tasks, and productivity.",
        // },
      ],
    },
  ];
  const cardRef1 = useRef(null);
  const cardRef2 = useRef(null);
  const cardRef3 = useRef(null);
  const cardRef4 = useRef(null);
  const cardRef5 = useRef(null);

  useEffect(() => {
    let direction = -1;
    let y = 0;

    const interval = setInterval(() => {
      y += direction * 0.5;
      if (y <= -5 || y >= 5) direction *= -1;

      if (cardRef1.current) {
        cardRef1.current.style.transform = `translateY(${y}px)`;
      }
      if (cardRef2.current) {
        cardRef2.current.style.transform = `translateY(${-y}px)`;
      }
      if (cardRef3.current) {
        cardRef3.current.style.transform = `translateY(${y}px)`;
      }
      if (cardRef4.current) {
        cardRef4.current.style.transform = `translateY(${y}px)`;
      }
      if (cardRef5.current) {
        cardRef5.current.style.transform = `translateY(${y}px)`;
      }
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const [selectedCountry, setSelectedCountry] = useState("India");

  const countries = [
    { name: "India", flag: ind },
    { name: "Malaysia", flag: mala },
    { name: "Dubai", flag: dubai },
    { name: "London", flag: london },
  ];

  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "30px",
    width: "100%",
    maxWidth: "400px",
    height: "auto",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "clamp(16px, 3vw, 32px)",
    fontFamily: "sans-serif",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    margin: "4px",
  };

  const logoStyle = {
    width: "clamp(120px, 20vw, 180px)",
    height: "auto",
    marginBottom: "clamp(16px, 2vw, 24px)",
  };

  const titleStyle = {
    fontSize: "clamp(16px, 2vw, 18px)",
    fontWeight: "bold",
    color: "#1b1b1b",
    marginBottom: "clamp(12px, 1.5vw, 16px)",
    textAlign: "left",
  };

  const addressStyle = {
    fontSize: "clamp(13px, 1.5vw, 15px)",
    color: "#333",
    lineHeight: "1.7",
    marginBottom: "clamp(8px, 1vw, 10px)",
    textAlign: "left",
  };

const renderEmail = (emailAddress) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "clamp(16px, 2vw, 20px)",
    }}
  >
    <div style={{ width: "20px", height: "20px" }}>
      <img
        src={email1} // Replace with your actual email icon path
        alt="Email"
        style={{ width: "100%", height: "100%" }}
      />
    </div>
    <a
      href={`mailto:${emailAddress}`}
      style={{
        fontSize: "clamp(13px, 1.5vw, 15px)",
        color: "#333",
        textDecoration: "none",
      }}
    >
      {emailAddress}
    </a>
  </div>
);



const renderPhone = (phoneNumber) => {
  const cleanedNumber = phoneNumber.replace(/[^+\d]/g, ""); // Remove spaces, brackets etc.




 

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "clamp(16px, 2vw, 24px)",
      }}
    >
      <div style={iconWrapperStyle}>
        <img
          src={phone1}
          alt="Phone"
          style={{ width: "clamp(14px, 1.5vw, 16px)" }}
        />
      </div>
      <a
        href={`https://wa.me/${cleanedNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          fontSize: "clamp(13px, 1.5vw, 15px)",
          color: "#333",
          textDecoration: "none",
        }}
      >
        {phoneNumber}
      </a>
    </div>
  );
};


const renderButton = (url) => {
  if (!url) return null; // Prevent rendering broken buttons
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        textDecoration: "none",
        display: "inline-block",
        width: "100%",
        maxWidth: "clamp(300px, 90%, 380px)",
      }}
    >
      <div
        style={{
          backgroundColor: "#EDF5FF",
          borderRadius: "100px",
          padding: "clamp(5px, 1vw, 7px) clamp(8px, 2vw, 10px)",
          color: "#004BA8",
          fontSize: "clamp(13px, 1.5vw, 15px)",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "clamp(8px, 1vw, 10px)",
          cursor: "pointer",
          height: "clamp(40px, 5vw, 48px)",
          justifyContent: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        Contact us
        <img
          src={right}
          alt="Arrow"
          style={{ width: "clamp(12px, 1.5vw, 14px)" }}
        />
      </div>
    </a>
  );
};





  const iconWrapperStyle = {
    backgroundColor: "#f2f6fd",
    borderRadius: "50%",
    padding: "clamp(3px, 0.5vw, 4px)",
    width: "clamp(18px, 2vw, 20px)",
    height: "clamp(18px, 2vw, 20px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const isMobile = screenWidth <= 768;
  const isTablet = screenWidth > 768 && screenWidth <= 1024;

  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };

  return (
    <div>
           <ToastContainer
      position="bottom-right"
      autoClose={3000}
      style={{ bottom: "80px" }}
    />
      {/* Global Responsive Styles */}
      {/* <style>
        {`
          @media (max-width: 768px) {
            .floating-button-container {
              bottom: 20px;
              right: 20px;
            }
            .floating-button img {
              width: 40px;
              height: 40px;
            }
          }

          @media (max-width: 1024px) {
            .dropdown-container {
              grid-template-columns: 1fr;
              padding: 16px;
            }
            .card-container {
              flex-direction: column;
              align-items: center;
            }
            .compliance-row {
              flex-direction: column;
              align-items: center;
            }
            .footer-section {
              flex-direction: column;
              align-items: center;
              text-align: center;
            }
            .footer-section img {
              margin-bottom: 20px;
            }
            .contact-form {
              width: 100%;
              max-width: 100%;
            }
            .newsletter-section {
              flex-direction: column;
              align-items: center;
              text-align: center;
              padding: 20px;
            }
            .newsletter-input {
              min-width: 100%;
            }
            .compliance-title {
              padding-left: 20px !important;
              text-align: center;
            }
          }

          @media (max-width: 480px) {
            .header-nav {
              flex-direction: column;
              gap: 10px;
            }
            .header-buttons {
              flex-direction: column;
              gap: 10px;
              width: 100%;
            }
            .header-buttons button {
              width: 100%;
            }
            .hero-title {
              font-size: 28px !important;
            }
            .country-selector {
              flex-direction: column;
              gap: 10px;
            }
            .country-item {
              width: 100%;
              justify-content: flex-start;
            }
            .compliance-item {
              width: 100%;
              max-width: 100%;
            }
            .contact-image {
              width: 100%;
              max-width: 280px;
            }
          }

          @media (min-width: 1025px) and (max-width: 1440px) {
            .card-container {
              gap: 20px;
            }
            .compliance-row {
              gap: 20px;
            }
          }
        `}
      </style> */}

      {/* Floating Button */}
      {/* <div className="floating-button-container">
        <button className="floating-button">
          <img src={icon} alt="button icon" />
        </button>
      </div> */}

      <>
        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            position: "sticky",
            top: 0,
            zIndex: 1000,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: isMobile ? "10px 3%" : "10px 5%",
            backgroundColor: "#0054BD",
            flexWrap: "wrap",
          }}
        >
      <Link to="/">
  <img
    src={logo1}
    alt="Logo"
    style={{
      maxWidth: isMobile ? "120px" : "130px",
      height: "auto",
      marginLeft: isMobile ? "-10px" : "-35px",
      cursor: "pointer", // Optional: shows clickable cursor
    }}
  />
</Link>

          {/* Mobile Hamburger Icon */}
          {/* Mobile Hamburger Icon */}
          {isMobile && (
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <svg
                width="24"
                height="24"
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          )}

          {/* Desktop/Tablet Menu */}
          {!isMobile && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexDirection: "row",
                width: "auto",
                backgroundColor: "transparent",
                padding: "0",
              }}
            >
           {["Products", "Partner", "Say Hello"].map((item, index) => (
                   <div
                     key={index}
                     style={{ position: "relative", width: "auto" }}
                     onMouseEnter={() => {
                       setHoveredItem(item);
                       if (item === "Products") setShowDropdown(true);
                     }}
                     onMouseLeave={() => {
                       setHoveredItem(null);
                       if (item === "Products") setShowDropdown(false);
                     }}
                   >
                     <div
                       onClick={() => handleClick(item)}
                       style={{
                         fontSize: "clamp(12px, 2vw, 16px)",
                         cursor: "pointer",
                         fontWeight: "normal",
                         backgroundColor:
                           activeItem === item || hoveredItem === item
                             ? "#014BA8"
                             : "transparent",
                         padding: "8px 16px",
                         borderRadius: "20px",
                         transition: "background-color 0.3s",
                         display: "flex",
                         color:"#fff",
                         alignItems: "center",
                         gap: "6px",
                         justifyContent: "flex-start",
                       }}
                     >
                       {item}
                       {item === "Products" && (
                         <img
                           src={down1}
                           alt="Down Arrow"
                           style={{
                             width: "10px",
                             height: "7px",
                             transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                             transition: "transform 0.3s",
                           }}
                         />
                       )}
                     </div>
           
                       {item === "Products" && showDropdown && (
                                 <div
                                   onMouseEnter={() => setShowDropdown(true)}
                                   onMouseLeave={() => setShowDropdown(false)}
                                   style={{
                                     position: "fixed",
                                     top: 30,
                                     left: "50%",
                                     transform: "translateX(-50%)",
                                     zIndex: 9999,
                                     marginTop: "20px",
                                     backgroundColor: "#FFFFFF",
                                     boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                     borderRadius: "24px",
                                     overflow: "hidden",
                                     width: "min(980px, 90vw)",
                                     maxWidth: "100%",
                                     padding: "16px",
                                     display: "grid",
                                     gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                                     gap: "16px",
                                     boxSizing: "border-box",
                                   }}
                                 >
                                   {dropdownItems.map((section, i) => (
                                     <div
                                       key={i}
                                       style={{
                                         paddingRight:
                                           i < dropdownItems.length - 1 ? "16px" : undefined,
                                         borderRight:
                                           i < dropdownItems.length - 1
                                             ? "1px solid #E0E0E0"
                                             : "none",
                                       }}
                                     >
                                       <div
                                         style={{
                                           color: "#666",
                                           fontWeight: 600,
                                           marginBottom: 12,
                                           textTransform: "uppercase",
                                           fontSize: 12,
                                         }}
                                       >
                                         {section.title}
                                       </div>
                     
                                       {section.items.map((product, j) => (
                                         <div
                                           key={j}
                                           style={{
                                             display: "flex",
                                             alignItems: "flex-start",
                                             gap: 10,
                                             padding: "8px",
                                             cursor: "pointer",
                                             marginBottom: 8,
                                             borderRadius: 8,
                                             transition: "background-color 0.3s ease",
                                           }}
                                           onClick={() => {
                                             if (product.name === "Gate") navigate("/gate");
                                             else if (product.name === "MeetQ") navigate("/meetq");
                                           }}
                                           onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = "#F0F8FF";
                                             const name = e.currentTarget.querySelector(
                                               ".product-name"
                                             );
                                             const arrow = e.currentTarget.querySelector(".arrow-icon");
                                             if (name) name.style.color = "#004aad";
                                             if (arrow) {
                                               arrow.style.filter =
                                                 "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                                               arrow.style.transform = "translateX(4px)";
                                             }
                                           }}
                                           onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = "transparent";
                                             const name = e.currentTarget.querySelector(
                                               ".product-name"
                                             );
                                             const arrow = e.currentTarget.querySelector(".arrow-icon");
                                             if (name) name.style.color = "inherit";
                                             if (arrow) {
                                               arrow.style.filter = "none";
                                               arrow.style.transform = "translateX(0)";
                                             }
                                           }}
                                         >
                                           <img
                                             src={product.icon}
                                             alt={product.name}
                                             style={{ width: 20, height: 20 }}
                                           />
                                           <div>
                                             <div
                                               className="product-name"
                                               style={{
                                                 fontWeight: 600,
                                                 display: "flex",
                                                 alignItems: "center",
                                                 transition: "color 0.3s ease",
                                                 fontSize: 13,
                                               }}
                                             >
                                               {product.name}
                                               <img
                                                 className="arrow-icon"
                                                 src={nr}
                                                 alt="arrow"
                                                 style={{
                                                   marginLeft: 4,
                                                   width: 16,
                                                   height: 16,
                                                   transition: "filter 0.3s ease, transform 0.3s ease",
                                                 }}
                                               />
                                             </div>
                                             <div
                                               style={{
                                                 color: "#666",
                                                 fontSize: 12,
                                                 textAlign: "left",
                                                 lineHeight: 1.4,
                                               }}
                                             >
                                               {product.description}
                                             </div>
                                           </div>
                                         </div>
                                       ))}
                                     </div>
                                   ))}
                                 </div>
                               )}
                   </div>
                 ))}

              <div
                style={{ display: "flex", justifyContent: "end", gap: "8px" }}
              >
                <button
                  onClick={() =>
                    (window.location.href = "http://app.mawalog.com/login")
                  }
                  className="login-button"
                  style={{
                    padding: "10px 20px",
                    borderRadius: "20px",
                    border: "1px solid #004aad",
                    backgroundColor: "#fff",
                    color: "#004aad",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "16px",
                    transition: "background-color 0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f0f4ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#fff")
                  }
                >
                  Login
                </button>
                <button
                  onClick={() =>
                    window.open("https://app.mawalog.com/register", "_blank")
                  }
                  className="register-button"
                  style={{
                    padding: "10px 20px",
                    borderRadius: "20px",
                    border: "none",
                    backgroundColor: "#004aad",
                    border: "1px solid #fff",
                    color: "#fff",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "16px",
                    transition: "background-color 0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#003a94")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#004aad")
                  }
                >
                  Register
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Mobile Menu */}
        {isMobile && isMobileMenuOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "#fff",
              padding: "20px",
              overflowY: "auto",
              zIndex: 1001,
              boxSizing: "border-box",
              fontFamily: "Epilogue, sans-serif",
            }}
          >
            {/* Header with Logo and Close Button */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
           <Link to="/">
  <img
    src={logo}
    alt="Logo"
    style={{ width: "120px", height: "auto", cursor: "pointer" }}
  />
</Link>
              <button
                onClick={() => setIsMobileMenuOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="#181835"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Navigation Items */}
            {[ "Products", "Partner", "Say Hello"].map((item, index) => (
              <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                {item === "Products" ? (
                  <>
                    <div
                      onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                      style={{
                        fontSize: "16px",
                        cursor: "pointer",
                        fontWeight: "600",
                        color: "#004aad",
                        padding: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "8px",
                        transition: "background-color 0.3s",
                        textAlign: "center",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#F0F8FF")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "transparent")
                      }
                    >
                      Products
                      <img
                        src={down}
                        alt="Arrow"
                        style={{
                          width: "10px",
                          height: "7px",
                          transform: mobileProductsOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s",
                        }}
                      />
                    </div>
                    {mobileProductsOpen && (
                      <div
                        style={{
                          marginTop: "12px",
                          padding: "16px",
                          backgroundColor: "#F9FAFB",
                          borderRadius: "12px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          maxWidth: "100%",
                          overflow: "auto",
                          boxSizing: "border-box",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {dropdownItems.map((section, i) => (
                          <div
                            key={i}
                            style={{
                              marginBottom: "16px",
                              width: "100%",
                              maxWidth: "90%",
                            }}
                          >
                            <div
                              style={{
                                color: "#666",
                                fontWeight: "600",
                                textTransform: "uppercase",
                                fontSize: "12px",
                                marginBottom: "8px",
                              }}
                            >
                              {section.title}
                            </div>
                            {section.items.map((product, j) => (
                              <div
                                key={j}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: "8px",
                                  cursor: "pointer",
                                  borderRadius: "8px",
                                  transition: "background-color 0.3s ease",
                                  maxWidth: "100%",
                                }}
                                onClick={() => {
                                  if (product.name === "Gate")
                                    navigate("/gate");
                                  else if (product.name === "MeetQ")
                                    navigate("/meetq");
                                  setIsMobileMenuOpen(false);
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#F0F8FF";
                                  const name =
                                    e.currentTarget.querySelector(
                                      ".product-name"
                                    );
                                  name.style.color = "#004aad";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "transparent";
                                  const name =
                                    e.currentTarget.querySelector(
                                      ".product-name"
                                    );
                                  name.style.color = "inherit";
                                }}
                              >
                                <img
                                  src={product.icon}
                                  alt={product.name}
                                  style={{ width: "20px", height: "20px" }}
                                />
                                <div style={{ flex: 1, overflow: "hidden" }}>
                                  <div
                                    className="product-name"
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      transition: "color 0.3s ease",
                                      whiteSpace: "normal",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "center",
                                    }}
                                  >
                                    {product.name}
                                  </div>
                                  <div
                                    style={{
                                      color: "#666",
                                      fontSize: "12px",
                                      lineHeight: "1.4",
                                      overflowWrap: "break-word",
                                      textAlign: "center",
                                    }}
                                  >
                                    {product.description}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                        <a
                          href="#"
                          style={{
                            color: "#004aad",
                            fontWeight: "600",
                            fontSize: "14px",
                            textDecoration: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "8px",
                          }}
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Explore all products
                          <img
                            src={right}
                            alt="arrow"
                            style={{
                              marginLeft: "4px",
                              width: "16px",
                              height: "16px",
                              verticalAlign: "middle",
                            }}
                          />
                        </a>
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    onClick={() => {
                      handleClick(item);
                      setIsMobileMenuOpen(false);
                    }}
                    style={{
                      fontSize: "16px",
                      cursor: "pointer",
                      fontWeight: "600",
                      color: "#004aad",
                      padding: "12px",
                      borderRadius: "8px",
                      transition: "background-color 0.3s",
                      textAlign: "center",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#F0F8FF")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    {item}
                  </div>
                )}
              </div>
            ))}

            {/* Buttons */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                width: "100%",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => {
                  window.location.href = "http://app.mawalog.com/login";
                  setIsMobileMenuOpen(false);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "1px solid #004aad",
                  backgroundColor: "#fff",
                  color: "#004aad",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: "14px",
                  width: "100%",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f0f4ff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fff")
                }
              >
                Login
              </button>
              <button
                onClick={() => {
                  window.open("https://app.mawalog.com/register", "_blank");
                  setIsMobileMenuOpen(false);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "none",
                  backgroundColor: "#004aad",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: "14px",
                  width: "100%",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#003a94")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#004aad")
                }
              >
                Register
              </button>
            </div>
          </div>
        )}









        

        {/* Media Queries for Tablet Button Size */}
        <style>
          {`
               @media (min-width: 769px) and (max-width: 1024px) {
                 .login-button, .register-button {
                   padding: 8px 16px !important;
                   font-size: 14px !important;
                 }
               }
             `}
        </style>
      </>

      <div style={{ width: "100%", overflowX: "hidden" }}>
        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            backgroundColor: "#0054BD",
            padding: "clamp(16px, 3vw, 20px) 0",
            color: "#ffffff",
            borderBottomLeftRadius: "clamp(40px, 10vw, 80px)",
            borderBottomRightRadius: "clamp(40px, 10vw, 80px)",
          }}
        >
          <div
            style={{
              maxWidth: "clamp(800px, 90vw, 1200px)",
              margin: "0 auto",
              padding: "0 clamp(16px, 3vw, 20px)",
            }}
          >
            <div
              style={{
                fontSize: "clamp(28px, 5vw, 50px)",
                fontWeight: "bold",
                marginBottom: "clamp(8px, 1vw, 10px)",
                textAlign: "center",
              }}
              className="hero-title"
            >
              Our partnership thrives
              <br />
              on vision & success
            </div>
            <div
              style={{
                fontSize: "clamp(14px, 1.5vw, 16px)",
                maxWidth: "clamp(600px, 80vw, 800px)",
                margin: "0 auto",
                textAlign: "center",
                color: "#e0e0e0",
                lineHeight: "1.6",
                padding: "0 clamp(16px, 3vw, 20px)",
              }}
            >
              Our partnership flourishes because it is rooted in{" "}
              <span style={{ fontWeight: "bold", color: "#ffffff" }}>
                trust
              </span>
              ,{" "}
              <span style={{ fontWeight: "bold", color: "#ffffff" }}>
                ensuring reliability and integrity
              </span>
              , guided by a shared vision that aligns our goals, and driven by
              success, reflecting our commitment to growth and achievement
              together.
            </div>

            <>
              <style>
                {`
      @media (max-width: 600px) {
        .country-selector {
          justify-content: center !important;
        }
        .card-container {
          justify-content: center !important;
        }
      }
    `}
              </style>

              
              <div
                style={{
                  background:
                    "linear-gradient(to bottom right, #0047AB, #003D99)",
                  borderRadius: "50px",
                  padding: "5px",
                  display: "flex",
                  gap: "clamp(4px, 1vw, 6px)",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: "clamp(400px, 80vw, 600px)",
                  margin: "clamp(20px, 3vw, 30px) auto",
                  flexWrap: "wrap",
                  overflowX: "auto",
                  paddingLeft: "clamp(8px, 1vw, 10px)",
                }}
                className="country-selector"
              >
                {countries.map((country, index) => {
                  const isSelected = country.name === selectedCountry;
                  return (
                    <div
                      key={index}
                      onClick={() => setSelectedCountry(country.name)}
                      style={{
                        backgroundColor: isSelected ? "#ffffff" : "transparent",
                        color: isSelected ? "#000000" : "#ffffff",
                        borderRadius: "25px",
                        padding:
                          "clamp(4px, 0.8vw, 6px) clamp(10px, 1.5vw, 14px)",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        fontSize: "clamp(12px, 1.5vw, 14px)",
                        boxShadow: isSelected
                          ? "0 4px 6px rgba(0,0,0,0.1)"
                          : "none",
                        transition: "all 0.3s ease",
                        minWidth: "clamp(80px, 20vw, 100px)",
                        justifyContent: "center",
                        gap: "clamp(4px, 0.8vw, 6px)",
                        flex: "0 0 auto",
                      }}
                      className="country-item"
                    >
                      <img
                        src={country.flag}
                        alt={country.name}
                        style={{
                          width: "clamp(16px, 2vw, 20px)",
                          height: "clamp(10px, 1.5vw, 14px)",
                          objectFit: "cover",
                          borderRadius: "3px",
                          maxWidth: "100%",
                        }}
                      />
                      <span>{country.name}</span>
                    </div>
                  );
                })}
              </div>

              
              <div
  style={{
    padding: "clamp(20px, 3vw, 34px)",
    display: "flex",
    justifyContent: "center",
    gap: "clamp(8px, 2vw, 10px)",
    flexWrap: "wrap",
    boxSizing: "border-box",
    wordBreak: "break-word",
  }}
  className="card-container"
>
  {selectedCountry === "India" ? (
    <>
      <div ref={cardRef1} style={cardStyle}>
        <img src={len} alt="Lentera" style={{ ...logoStyle, maxWidth: "100%" }} />
        <div style={titleStyle}>Lentera Technologies Private Limited</div>
        <div style={addressStyle}>
          G1, Plot No, 824 and 826, 3rd Main Rd, Ram Nagar South, <br />
          Madipakkam, Chennai, Tamil Nadu 600091.
        </div>
        {renderEmail("info@lenteratech.com")}
        {renderPhone("+91-44-4856-3345")}
        {renderButton("https://lenteratech.com")}
      </div>

      <div ref={cardRef2} style={cardStyle}>
        <img src={osai} alt="Osai" style={{ ...logoStyle, maxWidth: "100%" }} />
        <div style={titleStyle}>Osai eBiz Integrators Private Limited</div>
        <div style={addressStyle}>
          Mookambika Complex, No 15, Old No. 4, New No 7, Sir Desika Road,
          Mylapore, Chennai, Tamil Nadu 600004
        </div>
        {renderEmail("globalsales@osaiebiz.com")}
        {renderPhone("+91-9940087584")}
        {renderButton("https://www.osaiebiz.com")}
      </div>
    </>
  ) : selectedCountry === "Malaysia" ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        animation: "slideInFromRight 0.5s ease-in-out",
      }}
    >
      <div ref={cardRef3} style={cardStyle}>
        <img src={keesha} alt="Keesha" style={{ ...logoStyle, maxWidth: "100%" }} />
        <div style={titleStyle}>Keesha Saphalata</div>
        <div style={addressStyle}>
          13A, Dollomite Business Park, Jalan Batu Caves, 68100 Selangor, Malaysia
        </div>
        {renderEmail("Info@keeshasystem.com.my")}
        {renderPhone("(603)-27700-311")}
        {renderButton("https://keeshasystem.com.my/about-us/")}
      </div>
    </div>
  ) : selectedCountry === "Dubai" ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        animation: "slideInFromRight 0.5s ease-in-out",
      }}
    >
      <div ref={cardRef4} style={cardStyle}>
        <img
          src={du}
          alt="Dubai Office"
          style={{
            ...logoStyle,
            width: "clamp(60px, 15vw, 80px)",
            height: "auto",
            maxWidth: "100%",
          }}
        />
        <div style={titleStyle}>Quaestum Enterprises - Dubai</div>
        <div style={addressStyle}>Quaestum Enterprises, Dubai, UAE.</div>
        {renderEmail("tech@quaestum-ent.com")}
        {renderPhone("+971559936828")}
        {renderButton("https://quaestum-ent.com/")}
      </div>
    </div>
  ) : selectedCountry === "London" ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        animation: "slideInFromRight 0.5s ease-in-out",
      }}
    >
      <div ref={cardRef5} style={cardStyle}>
        <img src={lon} alt="IPT Infotech" style={{ ...logoStyle, maxWidth: "100%" }} />
        <div style={titleStyle}>IPT Infotech</div>
        <div style={addressStyle}>
          Registration no. 11018254, 11 Maylands Business Centre, Redbourn Road,
          Hemel Hempstead, HP2 7ES
        </div>
        {renderEmail("admin@iptinfotech.com")}
        {renderPhone("+44 1442 508156")}
        {renderButton("https://learning.iptinfotech.com/login")}
      </div>
    </div>
  ) : null}
</div>

            </>
          </div>
        </div>
      </div>

      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          backgroundColor: "#fafafa",
          fontFamily: "sans-serif",
          padding: "clamp(40px, 5vw, 60px) clamp(16px, 3vw, 20px)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "clamp(20px, 3vw, 40px)",
            maxWidth: "clamp(800px, 90vw, 1200px)",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              maxWidth: "clamp(360px, 45vw, 460px)", // Slightly reduced to balance with form
              marginLeft: "clamp(8px, 2vw, 16px)", // Reduced margin for better spacing
              flex: "1 1 clamp(300px, 40%, 460px)", // Ensure flexibility
            }}
          >
            <p
              style={{
                color: "#004BA8",
                fontWeight: "600",
                fontSize: "clamp(12px, 1.5vw, 14px)",
                margin: "0 0 clamp(6px, 1vw, 8px) 0",
              }}
            >
              CONNECT NOW
            </p>
            <h2
              style={{
                fontSize: "clamp(24px, 3.5vw, 42px)",
                fontWeight: "700",
                lineHeight: "1.2",
                margin: "clamp(8px, 1vw, 10px) 0",
                color: "#1A1A1A",
              }}
            >
              Want to enquire
              <br />
              about our products
            </h2>
            <p
              style={{
                fontSize: "clamp(12px, 1.5vw, 16px)",
                color: "#6e6e6e",
                marginBottom: "clamp(20px, 3vw, 30px)",
              }}
            >
              Feel free to reach out to our team.
            </p>

            <img
              src={man}
              alt="Contact person"
              style={{
                width: "clamp(200px, 80%, 340px)", // Adjusted for better fit
                height: "clamp(160px, 50vw, 280px)", // Adjusted height
                borderRadius: "12px",
                objectFit: "cover",
                display: "block",
              }}
              className="contact-image"
            />
          </div>

          <>
            <style>
              {`
          @keyframes floatUpDown {
            0% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0); }
          }
        `}
            </style>

            <div
              style={{
                backgroundColor: "#ffffff",
                padding: "clamp(16px, 3vw, 40px)",
                borderRadius: "32px",
                width: "clamp(280px, 45vw, 460px)",
                border: "1px solid #E5E5E5",
                marginRight: "clamp(8px, 2vw, 16px)", // Reduced margin for better spacing
                animation: "floatUpDown 4s ease-in-out infinite",
                flex: "1 1 clamp(280px, 40%, 460px)", // Ensure flexibility
              }}
              className="contact-form"
            >
              <h3
                style={{
                  fontSize: "clamp(18px, 2.5vw, 28px)",
                  fontWeight: "700",
                  marginBottom: "clamp(8px, 1vw, 10px)",
                  color: "#1A1A1A",
                }}
              >
                Get in touch with us
              </h3>
              <p
                style={{
                  color: "#6e6e6e",
                  marginBottom: "clamp(20px, 3vw, 30px)",
                  fontSize: "clamp(12px, 1.5vw, 15px)",
                }}
              >
                Reach out to us to partner with MAWALOG.
              </p>

          <input
  type="text"
  placeholder="Your name"
  value={name}
  onChange={(e) => setName(e.target.value)}
  style={getInputStyle("name")}
  onFocus={() => setFocusedField("name")}
  onBlur={() => setFocusedField(null)}
/>

<div
  style={{
    display: "flex",
    gap: "clamp(8px, 1vw, 10px)",
    flexWrap: "wrap",
  }}
>
  <input
    type="email"
    placeholder="Email"
    value={emaill}
    onChange={(e) => setEmaill(e.target.value)}
    style={{
      ...getInputStyle("email"),
      flex: 1,
      minWidth: "clamp(120px, 40%, 150px)",
    }}
    onFocus={() => setFocusedField("email")}
    onBlur={() => setFocusedField(null)}
  />

  <input
    type="tel"
    placeholder="Phone number"
    value={phone}
    onChange={(e) => setPhone(e.target.value)}
    style={{
      ...getInputStyle("phone"),
      flex: 1,
      minWidth: "clamp(120px, 40%, 150px)",
    }}
    onFocus={() => setFocusedField("phone")}
    onBlur={() => setFocusedField(null)}
  />
</div>

<textarea
  placeholder="Message"
  rows={4}
  value={message}
  onChange={(e) => setMessage(e.target.value)}
  style={{
    ...getInputStyle("message"),
    resize: "none",
    fontFamily: "inherit",
    paddingTop: "12px",
  }}
  onFocus={() => setFocusedField("message")}
  onBlur={() => setFocusedField(null)}
/>


              <button
                style={{
                  backgroundColor: "#004BA8",
                  color: "#ffffff",
                  border: "none",
                  padding: "clamp(12px, 1.5vw, 14px)",
                  width: "clamp(160px, 50%, 260px)",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  borderRadius: "40px",
                  fontSize: "clamp(14px, 1.5vw, 16px)",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
                onClick={handleSubmitt}
              >
                Send message
              </button>
            </div>
          </>
        </div>
      </div>

      {/* <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          padding: "clamp(30px, 5vw, 60px)",
          marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
        }}
      >
        <div
          style={{
            maxWidth: "clamp(800px, 90vw, 1200px)",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#181835",
                fontSize: "clamp(18px, 2.5vw, 22px)",
                fontWeight: "bold",
                paddingLeft:
                  screenWidth <= 1440
                    ? "clamp(50px, 10vw, 110px)"
                    : "clamp(100px, 12vw, 170px)",
                alignSelf: "flex-start",
              }}
            >
              Compliance of our company
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "clamp(10px, 2vw, 15px)",
                marginTop: "clamp(15px, 2vw, 20px)",
                flexWrap: "wrap",
              }}
            >
              {complianceData.slice(0, 3).map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F4F7FF",
                    width: "clamp(200px, 30vw, 270px)",
                    height: "clamp(35px, 5vw, 40px)",
                    padding: "clamp(4px, 1vw, 5px)",
                    borderRadius: "30px",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "background-color 0.3s, transform 0.3s ease",
                    marginBottom:
                      screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#EDF4FF";
                    e.currentTarget.style.transform = "scale(1.03)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#F4F7FF";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        borderRadius: "50%",
                        padding: "clamp(8px, 1.5vw, 10px)",
                        marginRight: "clamp(8px, 1.5vw, 12px)",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.title}
                        style={{
                          width: "clamp(30px, 4vw, 40px)",
                          height: "clamp(30px, 4vw, 40px)",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "#181835",
                        fontSize: "clamp(10px, 1.5vw, 12px)",
                        marginRight: "-10px",
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                  <img
                    src={riarr}
                    alt="Arrow"
                    style={{
                      width: "clamp(14px, 2vw, 18px)",
                      height: "clamp(14px, 2vw, 18px)",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "clamp(10px, 2vw, 15px)",
              marginTop: "clamp(15px, 2vw, 20px)",
              flexWrap: "wrap",
              marginRight:
                screenWidth <= 1024
                  ? "clamp(5px, 2vw, 10px)"
                  : "clamp(100px, 20vw, 290px)",
            }}
          >
            {complianceData.slice(3, 5).map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F4F7FF",
                  width: "clamp(200px, 30vw, 270px)",
                  height: "clamp(35px, 5vw, 40px)",
                  padding: "clamp(4px, 1vw, 5px)",
                  borderRadius: "30px",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  transition: "background-color 0.3s, transform 0.3s ease",
                  marginBottom:
                    screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#EDF4FF";
                  e.currentTarget.style.transform = "scale(1.03)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#F4F7FF";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      borderRadius: "50%",
                      padding: "clamp(8px, 1.5vw, 10px)",
                      marginRight: "clamp(8px, 1.5vw, 12px)",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      style={{
                        width: "clamp(30px, 4vw, 40px)",
                        height: "clamp(30px, 4vw, 40px)",
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "#181835",
                      fontSize: "clamp(10px, 1.5vw, 12px)",
                      marginRight: "-10px",
                    }}
                  >
                    {item.title}
                  </span>
                </div>
                <img
                  src={riarr}
                  alt="Arrow"
                  style={{
                    width: "clamp(14px, 2vw, 18px)",
                    height: "clamp(14px, 2vw, 18px)",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          display: "flex",
          alignItems: "center",
          marginTop: "-20px",
          justifyContent: "center",
          backgroundColor: "#004BA8",
          padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
          color: "#fff",
        }}
        className="newsletter-section"
      >
        <div
          style={{
            marginRight: "clamp(20px, 3vw, 40px)",
            marginBottom: "clamp(16px, 2vw, 20px)",
          }}
        >
          <img
            src={news}
            alt="Newsletter"
            style={{
              width: "clamp(150px, 20vw, 200px)",
              height: "clamp(120px, 15vw, 170px)",
              animation: "floatImage 3s ease-in-out infinite",
            }}
          />
        </div>

        <style>
          {`
      @keyframes floatImage {
        0% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
        100% { transform: translateY(0); }
      }

      @media (max-width: 480px) {
        .newsletter-section {
          flex-direction: column;
          text-align: center;
          padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
        }
        .newsletter-section > div:first-child {
          margin-right: 0;
          margin-bottom: clamp(16px, 2vw, 20px);
        }
        .newsletter-section h2,
        .newsletter-section p,
        .newsletter-section > div > div,
        .newsletter-section > div > div:last-child {
          margin-left: 0;
        }
        .newsletter-section .newsletter-input {
          min-width: clamp(200px, 80vw, 260px);
        }
        .newsletter-section button {
        
          display: block;
        }
      }
    `}
        </style>

        <div className="newsletter-content">
                  {/* Title and Paragraph */}
                  <>
                    <style>
                      {`
              .newsletter-text {
                font-family: Epilogue;
                line-height: 1.4;
                font-size: 22px;
                margin-bottom: 10px;
                margin-left: 60px;
              }
        
              @media (max-width: 1024px) {
                .newsletter-text {
                  font-size: 20px;
                  margin-left: 50px;
                }
              }
        
              @media (max-width: 768px) {
                .newsletter-text {
                  font-size: 18px;
                  margin-left: 40px;
                }
              }
        
              @media (max-width: 480px) {
                .newsletter-text {
                  font-size: 16px;
                  margin-left: 30px;
                }
              }
            `}
                    </style>
        
                    <div className="newsletter-text">Subscribe to our Newsletter!</div>
                  </>
        
                  <>
                    <style>
                      {`
              .newsletter-description {
                font-size: 14px;
                margin-bottom: 20px;
                text-align: start;
                margin-left: 60px;
                max-width: 100%;
                box-sizing: border-box;
              }
        
              @media (max-width: 1024px) {
                .newsletter-description {
                  font-size: 13px;
                  margin-left: 50px;
                }
              }
        
              @media (max-width: 768px) {
                .newsletter-description {
                  font-size: 12.5px;
                  margin-left: 40px;
                }
              }
        
              @media (max-width: 480px) {
                .newsletter-description {
                  font-size: 9px; /* reduced more for small screens */
                  text-align: center;
              
                }
              }
            `}
                    </style>
        
                    <div className="newsletter-description">
                      Stay updated with our latest news, offers, and insights! Subscribe{" "}
                      <br />
                      for exclusive updates delivered straight to your inbox.
                    </div>
                  </>
        
                  
                <>
          <style>
            {`
              .input-wrapper {
                display: flex;
                align-items: center;
                position: relative;
                width: 100%;
                max-width: 400px;
                margin: 0 auto 10px auto; /* center aligned */
                flex-wrap: nowrap;
              }
        
              .email-input {
                padding: 14px 16px 14px 48px;
                border-radius: 10px;
                border: 1px solid #9FCAFF;
                outline: none;
                background-color: #00377B;
                color: #fff;
                flex: 1;
                width: 100%;
                box-sizing: border-box;
                font-size: 16px;
              }
        
              .email-icon {
                position: absolute;
                left: 16px;
                width: 20px;
                height: 20px;
              }
        
              /* Optional: Keep consistent appearance on all devices */
              @media (max-width: 480px) {
                .email-input {
                  padding: 12px 12px 12px 44px;
                  font-size: 14px;
                }
              }
            `}
          </style>
        
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <div className="input-wrapper">
              <img src={mail} alt="Email Icon" className="email-icon" />
              <input
                type="email"
                value={email}
                placeholder="sample@gmail.com"
                className="email-input"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
        
        
                 
                  <>
                    <style>{`
                .captcha-container {
                  display: flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  margin: 10px auto !important;
                  border-radius: 20px !important;    
                  gap: 8px !important;
                  flex-wrap: wrap !important;
                }
              .captcha-box {
          width: 60px !important;
          height: 40px !important;
          border-radius: 8px !important;
          background-color: #fff !important;
          box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          overflow: hidden !important; /* Add this to clip canvas overflow */
        }
        
        #captchaCanvas {
          border-radius: 20px !important;
        }
                .captcha-input {
                  padding:10px 1px!important;
                  border-radius:8px!important;
                  border:1px solid #ccc!important;
                  outline:none!important;
                  min-width:120px!important;
                  background:#00377B!important;
                  color:#fff!important;
                }
                .subscribe-button {
                  padding:14px 30px!important;
                  border-radius:12px!important;
                  border:none!important;
                  background:#fff!important;
                  color:#0A3A72!important;
                  font-weight:bold!important;
                  cursor:pointer!important;
                  margin-bottom:0!important;
                }
                @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
                @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
                @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
              `}</style>
        
                    <div className="captcha-container">
                      <div className="captcha-box">
                        <canvas
                          ref={canvasRef}
                          id="captchaCanvas"
                          width={60}
                          height={40}
                        />
                      </div>
        
                      <button
                        onClick={handleReload}
                        style={{
                          background: "#2563EB",
                          color: "#fff",
                          border: "none",
                          padding: "8px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {/* Your reload SVG icon here */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="23 4 23 10 17 10"></polyline>
                          <polyline points="1 20 1 14 7 14"></polyline>
                          <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                        </svg>
                      </button>
        
                      <input
                        type="text"
                        placeholder="Enter captcha"
                        value={userCaptcha}
                        onChange={(e) => setUserCaptcha(e.target.value)}
                        className="captcha-input"
                      />
        
                      <button className="subscribe-button" onClick={handleSubscribe}>
                        Subscribe
                      </button>
                    </div>
                  </>
        
                  {/* Note */}
                  <div
                    style={{
                      fontSize: "12px",
                      marginTop: "10px",
                      color: "#fff",
                      marginLeft:
                        window.innerWidth <= 480
                          ? "20px"
                          : window.innerWidth <= 768
                          ? "40px"
                          : window.innerWidth <= 1024
                          ? "50px"
                          : "60px",
                    }}
                  >
                    *Unsubscribe anytime. We don’t send any spam
                  </div>
                </div>
      </div>

     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "20px 10px" : "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
      marginBottom: "40px",
    }}
  >
    <Link to="/">
      <img
        src={logo}
        alt="Mawalog"
        style={{
          width: isMobile ? "150px" : "180px",
          height: "auto",
          display: "flex",
          justifyContent: "start",
          cursor: "pointer"  // shows it's clickable
        }}
      />
    </Link>
    <p
      style={{
        color: "#555",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: isMobile ? "20px" : "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply chain
      management by offering an integrated platform that combines manufacturing,
      logistics, and warehouse solutions partner with optimized logistics and a
      global network.
    </p>
    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: isMobile ? "0" : "-80px",
      }}
    >
      {[insta, face, youtube, link,twit].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: isMobile ? "20px" : "24px",
            height: isMobile ? "20px" : "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => {
            if (icon === face)
              window.open("https://www.facebook.com/mawalogone/", "_blank");
            if (icon === youtube)
              window.open("https://www.youtube.com/@mawalogone", "_blank");
            if (icon === insta)
              window.open("https://www.instagram.com/mawalogone/", "_blank");
            if (icon === link)
              window.open(
                "https://www.linkedin.com/company/mawalogone/",
                "_blank"
              )
              if (icon === twit)
              window.open("https://x.com/mawalogone", "_blank");
          }}
        />
      ))}
    </div>
  </div>

  <div
  style={{
    display: "flex",
    gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
    flexWrap: "wrap",
    justifyContent: isMobile ? "flex-start" : "space-between",
  }}
>
  <div>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
      }}
    >
      Know More
    </h4>
{["Opportunities", "Articles", "Our Story", "Help Center"].map(
  (item, index) => (
    <p
      key={index}
      style={{
        margin: "8px 0",
        color: "#555",
        cursor: "pointer",
        textAlign: "start",
        fontSize: isMobile ? "12px" : "14px",
        transition: "color 0.3s ease",
        paddingBottom: "2px",
      }}
      onClick={() => {
        switch (item) {
          case "Opportunities":
          case "Articles":
          case "Help Center":
            navigate("/coming");
            break;
          case "Our Story":
            navigate("/about");
            break;
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#555";
      }}
    >
      {item}
    </p>
  )
)}

  </div>

 <div>
      <h4
        style={{
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "bold",
          marginRight: isMobile ? "0" : "20px",
        }}
      >
        Legal &amp; Policies
      </h4>

 {[
  "Terms and Conditions",
  "Privacy Policy",
  "Cookie Policy",
  "Copyright Policy",
].map((item, index) => (
  <p
    key={index}
    style={{
      margin: "8px 0",
      color: "#555",
      cursor: "pointer",
      textAlign: "start",
      fontSize: isMobile ? "12px" : "14px",
      transition: "color 0.3s ease",
      paddingBottom: "2px",
    }}
    onClick={() => {
      const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
      const basePath =
        item === "Terms and Conditions"
          ? "/terms"
          : item === "Privacy Policy"
          ? "/policy"
          : item === "Cookie Policy"
          ? "/cookie"
          : item === "Copyright Policy"
          ? "/copyright"
          : "/";
      navigate(`${basePath}${targetId}`);
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
  >
    {item}
  </p>
))}

    </div>

</div>


  <div style={{ marginBottom: "40px" }}>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
        marginRight: isMobile ? "0" : "180px",
      }}
    >
      Contact us
    </h4>
    <a
      href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#004BA8",
        cursor: "pointer",
        fontSize: isMobile ? "12px" : "14px",
        textAlign: "start",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={ee}
        alt="Email"
        style={{
          width: isMobile ? "12px" : "14px",
          height: isMobile ? "12px" : "14px",
          marginRight: "8px",
        }}
      />
      info@mawalog.com
    </a>
    {[
      { phone: "603-27700-311", country: "Malaysia" },
      { phone: "+971-50-1234567", country: "UAE" },
      { phone: "+44 7911 123456", country: "UK" },
      { phone: "+91-44-4856-3345", country: "India" },
    ].map((contact, index) => (
      <p
        key={index}
        style={{
          fontSize: isMobile ? "12px" : "14px",
          textAlign: "start",
        }}
      >
        <img
          src={one}
          alt="Phone"
          style={{
            width: isMobile ? "12px" : "14px",
            height: isMobile ? "12px" : "14px",
            marginRight: "8px",
          }}
        />
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "#004BA8",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {contact.phone}
        </a>{" "}
        (<span style={{ color: "#000" }}>{contact.country}</span>)
      </p>
    ))}
  </div>

  <div
    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
    style={{ marginBottom: "40px", position: "relative" }}
  >
    <div style={{ position: "relative", display: "inline-block" }}>
      <a
        href="https://app.mawalog.com/register"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={trial}
          alt="Illustration"
          style={{
            width: isMobile ? "180px" : isTablet ? "200px" : "210px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
            animation: "shine 3s ease-in-out infinite",
          }}
        ></div>
      </div>
    </div>
    <style>
      {`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}
    </style>
  </div>
</div>


      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          textAlign: "center",
          padding: "clamp(16px, 2vw, 20px) 0",
          borderTop: "1px solid #ddd",
          fontSize: "clamp(12px, 1.5vw, 14px)",
          color: "#333",
        }}
      >
        Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
      </div>
    </div>
  );
};

export default Partner;
